import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { SelectItem } from "primeng/api";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { SelectedChipsComponent } from "../../chip/selected-chips.component";
import { Checkbox } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { quoteStatus } from "../../../quote/quote-form/quote-status.const";

@Component({
  selector: "app-quote-status-multiselect",
  templateUrl: "./quote-status-multiselect.component.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Checkbox, FormsModule, SelectedChipsComponent],
})
export class QuoteStatusMultiselectComponent implements OnInit {
  readonly appendTo = input("");
  readonly disabled = input(false);
  @Input() selectedStatuses: string[] = [];
  readonly selectionChange = output<string[]>();

  public statusList: SelectItem[] = [];

  ngOnInit() {
    this.buildStatusList();
  }

  public onStatusChange() {
    this.selectionChange.emit(this.selectedStatuses);
  }

  public readonly chipLabel = (status: string): string =>
    this.getStatusLabel(status);

  public removeStatus(status: string) {
    this.selectedStatuses = this.selectedStatuses.filter(
      (value) => value !== status,
    );
    this.onStatusChange();
  }

  public isSelected(status: string): boolean {
    return this.selectedStatuses?.includes(status) ?? false;
  }

  public getStatusLabel(status: string): string {
    return this.statusList.find((item) => item.value === status)?.label ?? "";
  }

  private buildStatusList() {
    Object.keys(quoteStatus).forEach((key) => {
      if (quoteStatus[key] !== quoteStatus.pending) {
        this.statusList.push({
          label: quoteStatus[key],
          value: key,
        });
      }
    });
  }
}
